export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_ACCRUALS = "GET_ACCRUALS";

export default {
  GET_PAYMENTS,
  GET_ACCRUALS
};
